import api from '../../plugins/api';

const getClients = (params) => {
  return api.get('/api/crm/clients/getClients', params);
};

export default getClients;
